angular.module('rjmNg.api').factory("FilterSets", [
  "$resource"
  "serviceUrl"
  "phpServiceUrl"
  "operatorEnums"
  "$cacheFactory"
  (
    $resource
    serviceUrl
    phpServiceUrl
    operatorEnums
    $cacheFactory
  ) ->

    filterSetsBaseUrl = serviceUrl("/clients/:clientId/filter-sets")
    restrictionsetBaseUrl = phpServiceUrl("/client/:clientId/restrictionset/:id/")

    defaultParams =
      withCredentials: true
      headers:
        Accept: 'application/json'
        'Content-Type': 'application/json'

    actions =
      get: angular.extend {}, defaultParams,
        method: 'GET'
        url: filterSetsBaseUrl
        isArray: true
        cache: $cacheFactory.get('FilterSets') or $cacheFactory('FilterSets')
      create: angular.extend {}, defaultParams,
        method: 'POST'
        url: filterSetsBaseUrl
      update: angular.extend {}, defaultParams,
        method: 'PUT'
        url: filterSetsBaseUrl + "/:id"
      delete:
        method: 'POST'
        url: restrictionsetBaseUrl + "delete"
      dependents:
        method: 'POST'
        url: restrictionsetBaseUrl + "dependents/"

    filterSetsResource = $resource(phpServiceUrl("/"), {}, actions)

    clearCache = () ->
      $cacheFactory.get('FilterSets')?.removeAll()

    FilterSets =
      get: (clientId, useCache = true) ->
        if not useCache
          clearCache()
        filterSetsResource.get(clientId: clientId).$promise
      create: (clientId, data) ->
        clearCache()
        filterSetsResource.create(clientId: clientId, data).$promise
      update: (clientId, id, data) ->
        clearCache()
        filterSetsResource.update({clientId: clientId, id: id}, data).$promise
      delete: (clientId, id) ->
        clearCache()
        filterSetsResource.delete({clientId: clientId, id: id}, {}).$promise
      dependents: (clientId, id) ->
        filterSetsResource.dependents({clientId: clientId, id: id}, {}).$promise

    FilterSets.filterSetsByTableIds = (clientId, tableIds=null) ->
      filterSetsResource.get(clientId: clientId).$promise
      .then(
        (filterSets) ->
          # Returns only the filterSets whose table_id is in tableIds, a list of table ids.
          # Returns all filter sets when tableIds is null
          return filterSets unless tableIds?
          filterSet for filterSet in filterSets when \
            tableIds.indexOf(filterSet.table_id) > -1
      , (error) ->
          error
      )

    FilterSets.buildTableHasFilterSetMap = (tables, filterSets) ->
      tableHasFilterSet = {}
      tableHasFilterSet[table.id] = false for table in tables
      tableHasFilterSet[filterSet.table_id] = true for filterSet in filterSets
      return tableHasFilterSet

    FilterSets.createDataForRequest = (tableId, filterSetName, restrictionSet) ->
      data =
        table_id: tableId
        name: filterSetName
        is_deleted: false
        sequence: restrictionSet.sequence.string or ""
        filters: []

      for restriction in restrictionSet.restrictions
        restrictionData =
          left:
            column_id: restriction.left.column_id
          right:
            value: restriction.right
          operation: operatorEnums.SCHEMA_SERVICE_COMPARISON_OPERATOR_SYMBOLS[restriction.op]
        data.filters.push(restrictionData)

      return data

    FilterSets
  ]
)
